﻿import { pickup_point } from './pickup_point';

export class pickup {
    public run_id: string | null = null;
    public error_information: string | null = null;
    public name: string | null = null;
    public points: pickup_point[] = [];
}